import { Injectable } from '@angular/core';
/** Default values provider for tooltip */
var TooltipConfig = (function () {
    function TooltipConfig() {
        /** tooltip placement, supported positions: 'top', 'bottom', 'left', 'right' */
        this.placement = 'top';
        /** array of event names which triggers tooltip opening */
        this.triggers = 'hover focus';
    }
    return TooltipConfig;
}());
export { TooltipConfig };
TooltipConfig.decorators = [
    { type: Injectable },
];
/** @nocollapse */
TooltipConfig.ctorParameters = function () { return []; };
//# sourceMappingURL=tooltip.service.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/tooltip/tooltip.service.js
// module id = ../../../../angular-bootstrap-md/tooltip/tooltip.service.js
// module chunks = 3